import _ from "lodash";
import { TOGGLE_LEFT, TOGGLE_RIGHT } from "./types";

export default function(state = {}, action) {

  switch (action.type)
  {
    case TOGGLE_LEFT:
    case TOGGLE_RIGHT:
      var open = action.open;
    console.log(open);
      if (typeof open === "undefined"){
        open = state.open !== action.type ? action.type : false;
        console.log(open);
      }
      document.body.classList.toggle('lockscroll', open)        
      return { ...state, open };
    break
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/data/menus/reducer.js